// import logo from './logo.svg';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "./styles/base.scss"

import HomePage from './components/HomePage';
import CashierPage from "./components/CashierPage";
import ClientScreen from "./components/ClientScreen";
import InvoicePage from "./components/InvoicePage";
import AdminPanel from "./components/AdminPanel";
import StandScreen from "./components/StandScreen";

const App = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="caisse" element={<CashierPage />} />
        <Route path="caisse/:code" element={<ClientScreen />} />
        <Route path="invoice/:id" element={<InvoicePage />} />
        <Route path="stand/:stand" element={<StandScreen />} />
        <Route path="admin" element={<AdminPanel />} />
      </Routes>
    </BrowserRouter>
  )
}

export default App;
